import {
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    Modal,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { useState } from 'react';

const PIAModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
    const [isChecked, setIsChecked] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Detects small screens

    return (
        <Modal open aria-labelledby='terms-modal' disableEscapeKeyDown>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '80%', // Default width
                    maxWidth: 640, // Restricts large screens
                    minWidth: { xs: '90%', sm: '60%', md: '50%' }, // Adaptive for screen sizes
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    p: { xs: 2, sm: 4 }, // Adjust padding for small screens
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    maxHeight: '90vh', // Prevents overflow on small screens
                    overflowY: 'auto', // Enables scrolling if needed
                }}
            >
                <Typography
                    id='terms-modal'
                    variant='h6'
                    fontWeight={600}
                    textAlign='center'
                >
                    Acknowledgement Notice
                </Typography>

                {/* Scrollable Content Box */}
                <Box
                    sx={{
                        maxHeight: '50vh',
                        overflowY: 'auto',
                        p: 2,
                        bgcolor: 'grey.100',
                        borderRadius: 1,
                        fontSize: { xs: '12px', sm: '14px' },
                    }}
                >
                    <Typography variant='body2'>Dear Customer,</Typography>
                    <Typography variant='body2'>
                        <p>
                            By accessing and using the Robi LBS service, you
                            hereby acknowledge and confirm the following:
                        </p>{' '}
                        <p>
                            You have obtained the necessary consent from your
                            employees for monitoring their movements through
                            this platform, as per applicable laws and
                            regulations.
                        </p>
                        <p>
                            Robi Axiata Limited is providing this platform as a
                            service to your organization, and Robi will not be
                            held liable to any individual or third party for any
                            monitoring activities conducted using this platform.
                        </p>
                        Please ensure that your usage of this service complies
                        with all relevant legal and regulatory requirements. By
                        clicking "Accept," you agree to the above terms and
                        conditions.
                    </Typography>
                </Box>

                {/* Policy Links */}
                <Box sx={{ textAlign: 'start' }}>
                    <Typography variant='body2'>
                        <a
                            href='https://www.robi.com.bd/en/personal/privacy-notice'
                            target='_blank'
                            rel='noopener noreferrer'
                            style={{
                                color: theme.palette.primary.main,
                                textDecoration: 'underline',
                            }}
                        >
                            Privacy Notice
                        </a>
                    </Typography>
                    <Typography variant='body2'>
                        <a
                            href='https://www.robi.com.bd/en/personal/cookies-policy'
                            target='_blank'
                            rel='noopener noreferrer'
                            style={{
                                color: theme.palette.primary.main,
                                textDecoration: 'underline',
                            }}
                        >
                            Cookies Policy
                        </a>
                    </Typography>
                </Box>

                {/* Checkbox and Button */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row', // Stack vertically on small screens
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 2,
                    }}
                >
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={isChecked}
                                onChange={(e) => setIsChecked(e.target.checked)}
                            />
                        }
                        label='Accept'
                    />
                    <Button
                        variant='contained'
                        color='info'
                        disabled={!isChecked}
                        onClick={onClose}
                    >
                        Agree and Continue
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default PIAModal;
